import React from 'react';
import {
  Edit, ReferenceField,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin';

import OnlySaveToolbar from '../components/only-save-toolbar';
import { redirectToReglaTab } from '../regla/regla-utils';

const redirectToReglaEditConfiguracionesTab = (basePath, id, data) => redirectToReglaTab(data.idRegla, 'configuraciones');

const ConfiguracionesGeneralesEdit = (props) => (
  <Edit mutationMode="optimistic" {...props}>
    <SimpleForm toolbar={<OnlySaveToolbar />} redirect={redirectToReglaEditConfiguracionesTab}>
      <ReferenceField source="idRegla" reference="regla"
                      link={false}>
        <TextField  source="descripcion" />
      </ReferenceField>
      <TextField source="clave" />
      <TextField source="descripcion" />
      <TextInput source="valor" />
    </SimpleForm>
  </Edit>
);

export default ConfiguracionesGeneralesEdit;
